import { OrderCancellationReason } from '@hero/schema';

type CancelConfig = Readonly<{
  reason: OrderCancellationReason;
  requriedNote?: boolean;
  target: ('customer' | 'admin' | 'carrier')[];
}>;

const otherConfig: CancelConfig = {
  reason: 'other',
  requriedNote: true,
  target: ['admin', 'carrier', 'customer'],
};

const customerCanceledConfig: CancelConfig = {
  reason: 'customer_canceled',
  requriedNote: false,
  target: ['admin'],
};

const noCarrierAvailableConfig: CancelConfig = {
  reason: 'no_carrier_available',
  requriedNote: false,
  target: ['admin'],
};

const customerChangeDateConfig: CancelConfig = {
  reason: 'customer_change_date',
  requriedNote: false,
  target: ['customer'],
};

const customerOrderMistakeConfig: CancelConfig = {
  reason: 'customer_order_mistake',
  requriedNote: false,
  target: ['customer'],
};

const cancelOptions: readonly CancelConfig[] = [
  noCarrierAvailableConfig,
  customerCanceledConfig,
  customerChangeDateConfig,
  customerOrderMistakeConfig,
  otherConfig,
];

export const cancelConfig = {
  cancelOptions,
};
